import { render, staticRenderFns } from "./BlogForm.vue?vue&type=template&id=60499ce8"
import script from "./BlogForm.vue?vue&type=script&lang=js"
export * from "./BlogForm.vue?vue&type=script&lang=js"
import style0 from "./BlogForm.vue?vue&type=style&index=0&id=60499ce8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports